import { ApiError } from "@/lib/api-client";

/** Below this the message is ours; at or above it, it is a stack trace's worth of nothing. */
const SERVER_ERROR_STATUS = 500;

/**
 * Shows the API's own words for a refused scheduler action.
 *
 * Scheduled Jobs is an operator surface — IAM gaps, conflict, and validation
 * copy are written for the person clicking Pause. The generic customer toast
 * would replace the only instruction they need. Server faults still fall back.
 */
export function scheduledJobErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError && error.status > 0 && error.status < SERVER_ERROR_STATUS) {
    return error.message;
  }
  return fallback;
}
